export default "__VITE_ASSET__WrrKqe1y__"